export const UPDATE_TITLE = 'UPDATE_TITLE';

const updateTitle = title => {
  return {
    type: UPDATE_TITLE,
    title,
  };
};

export { updateTitle };
